import { useLocation, useNavigate } from 'react-router-dom';
import FileExplorerCard from '../components/fileExplorer/FileExplorerCard';
import FileInsightsCard from '../components/fileExplorer/FileInsightsCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Select, Button, TextInput } from '@mantine/core';
import { getFolder } from '.././apis/agent';
import { useEffect, useState } from 'react';
import { DriveFileMove } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export default function FileExplorer() {
  const location = useLocation();
  const navigate = useNavigate();
  const [driveData, setDriveData] = useState({
    path: '',
    files: [],
    folders: [],
  });
  //console.log(location.state)
  const getExplorerParams = () => {
    if (location.state?.drive) {
      return {
        drive: location.state.drive,
        uuid: location.state.uuid,
        sys_uuid: location.state.sys_uuid,
        device_id: location.state.device_id,
        disabled :location.state.disabled,
        licence_id:location.state.licence_id,
        deletion:location.state.deletion,
        enc_dec:location.state.enc_dec
      };
    }
  };

  const params = getExplorerParams();
  const drive = params?.drive;
  const uuid = params?.uuid;
  const sys_uuid = params?.sys_uuid;
  const device_id = params?.device_id;
  const disabled=params?.disabled
  const licence_id=params?.licence_id
  const deletion=params?.deletion
  const enc_dec=params?.enc_dec

  const [pathCurrent, setPathCurrent] = useState(drive || '');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRippleEffect = (e) => {
    const button = e.currentTarget;
    const ripple = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
    ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
    ripple.classList.add('export-button-ripple');
    button.appendChild(ripple);
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  const fetchFiles = async () => {
    if (!drive || !uuid) {
      return;
    }
    try {
      const res = await getFolder(uuid, drive, sys_uuid);
      setDriveData({
        path: res.data.path,
        files: res.data.files,
        folders: res.data.folders,
      });
      //console.log(res)
      setPathCurrent(drive);
    } catch (err) {
      console.error('Failed to fetch files:', err);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, [drive, uuid, sys_uuid]);

  const handleFileChange = () => {
    setRefreshTrigger(prev => prev + 1);
    fetchFiles();
  };

  const handleBack = (e) => {
    handleRippleEffect(e);
    localStorage.removeItem('fileExplorerParams');
    navigate(-1);
  };

  if (!drive || !uuid) {
    return (
      <Box className="min-h-screen pt-4">
        <Box style={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
          <Box className="flex justify-between items-center mb-4">
            <Typography
            variant="h4"
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '32px',
                fontWeight: 700,
              }}
            >
              File Explorer - Error
            </Typography>
            <Button
              size="sm"
              variant="filled"
              className="export-button"
            
              onClick={handleBack}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{
                  height: '10px',
                  width: '10px',
                  color: '#fff',
                }}
              />
              <span>Back</span>
            </Button>
          </Box>
          <Box className="bg-white p-4 rounded-xl shadow-md">
            <p className="text-red-600">Error: Drive {drive} not found.</p>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box className="min-h-screen pt-4">
      <Box style={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
        <Box className="flex justify-between items-center mb-4">
          <Typography
          variant='h4'
            style={{
              fontFamily: 'Nunito Sans, sans-serif',
              fontSize: '32px',
              fontWeight: 700,
            }}
          >
            File Explorer - {drive}
          </Typography>
          <Button
            size="sm"
            variant="filled"
            className="export-button"
          
            onClick={handleBack}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{
                height: '10px',
                width: '10px',
                color: '#fff',
              }}
            />
            <span>Back</span>
          </Button>
        </Box>

        {FileExplorerCard ? (
          <FileExplorerCard
            key={drive}
            data={driveData}
            uuid={uuid}
            sys_uuid={sys_uuid}
            setPathCurrent={setPathCurrent}
            onFileChange={handleFileChange}
            device_id={device_id}
            disabled={disabled}
            licence_id={licence_id}
            deletion={deletion}
            enc_dec={enc_dec}
          />

        ) : (
          <Box className="bg-white p-4 rounded-xl shadow-md">
            <p className="text-red-600">Error: FileExplorerCard component not found.</p>
          </Box>
        )}

        <Box className="mt-6">
          <FileInsightsCard
            data={driveData}
            uuid={uuid}
            sys_uuid={sys_uuid}
            pathCurrent={pathCurrent}
            refreshTrigger={refreshTrigger}
            device_id={device_id}
            licence_id={licence_id}
             deletion={deletion}
            enc_dec={enc_dec}
          />
        </Box>
      </Box>

    </Box>
  );
}